/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentBookingStateTextWithIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Confirmed from './Confirmed/index'
import React from 'react'
import StateIcon from './StateIcon/index'
import StateText from './StateText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentBookingStateTextWithIcon({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon",
  fill2,
  size
  
}) {
let selectedShowIconValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'show_icon',
})
let selectedShowTextValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'show_text',
})
let selectedShowTextValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'show_text',
})
  return (<React.Fragment
>
<div
  data-testid="AppointmentBookingStateTextWithIcon.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={selectedShowIconValueData}>
<StateIcon
  viewPath={`${viewPath}/StateIcon`}
 fill2={fill2}
 data="selected.show_icon"
/>
</fromFlow.When>
<fromFlow.When is={selectedShowTextValueData}>
<StateText
  viewPath={`${viewPath}/StateText`}
 size={size}
 data="selected.show_text"
/>
</fromFlow.When>
<fromFlow.When is={selectedShowTextValueData1}>
<Confirmed
  viewPath={`${viewPath}/Confirmed`}
 size={size}
 data="selected.show_text"
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}